export default __webpack_public_path__ + "static/media/large.66e9523a.jpg";